import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import {
  getDecisionNodeAtPath,
  getSelectedOrderFromOrdersSearch,
  getSimplrAccountIdOfSelectedTicket,
} from '../../../../../../extractFromState';
import { getSelectedLineItems } from '../../../../../../selectors/tools';
import { replaceOrderItems } from '../../../../../../actions/tools/CommonAsyncOrderActions';
import DTSelectedItemTransactionView from '../../DTSelectedItemTransactionView';
import { useReasons } from '../../../../../../customHooks/decisionTree/useReasons';
import DTImageSelector from '../../../../Common/DTImageSelector/DTImageSelector';
import { withConfirmation } from '../../../../DTConfirmationView/withConfirmation';
import { BlankReasonContainer } from '../../../../Common/DTSelectReason/DTSelectReason.styles';
import { setShowConfirmationPage } from '../../../../../../actions/tools/OrdersSearchActions';
import { addEdgeToDecisionTreePath } from '../../../../../../actions/searchActions';
import { setLoading } from '../../../../../../actions';
import { REASON_TYPES } from 'constants/decisionTree';
import { handleError } from 'services/ErrorService/ErrorService';

const DTReplaceSelectedItemsNode = () => {
  const [selectedImages, setSelectedImages] = useState([]);
  const dispatch = useDispatch();
  const selectedLineItems = useSelector(getSelectedLineItems);
  const orderId = get(useSelector(getSelectedOrderFromOrdersSearch), 'orderId');
  const orderNumber = get(useSelector(getSelectedOrderFromOrdersSearch), 'orderNumber');
  const simplrAccountId = useSelector(getSimplrAccountIdOfSelectedTicket);
  const decisionNode = useSelector(getDecisionNodeAtPath);
  const { chargeShipping } = decisionNode;

  const { selectedReason, reasons, ReasonContainerComponent } = useReasons({
    loadingComponentName: 'itemTransactionContainer',
    skipImages: false,
    type: REASON_TYPES.REPLACE,
  });

  const handleReplaceButtonClick = async () => {
    try {
      dispatch(setLoading(true, 'itemTransactionContainer'));
      await dispatch(
        replaceOrderItems({
          simplrAccountId,
          orderId,
          orderNumber,
          reason: selectedReason,
          chargeShipping,
          items: selectedLineItems,
          imageUrls: selectedImages,
        })
      );
      dispatch(setShowConfirmationPage());
    } catch (error) {
      handleError({ error });
      dispatch(addEdgeToDecisionTreePath('transaction_failed'));
    } finally {
      dispatch(setLoading(false, 'itemTransactionContainer'));
    }
  };

  const isReasonsRequired = !isEmpty(reasons);
  const isImageRequired = !get(selectedReason, 'isImageOptional', true);
  const isReasonValid = !!selectedReason || !isReasonsRequired;
  const isNextEnabled = isReasonValid && (!isImageRequired || !isEmpty(selectedImages));

  return (
    <DTSelectedItemTransactionView
      nextButtonLabel="REPLACE"
      showContainer={!!reasons}
      isNextEnabled={isNextEnabled}
      nextButtonClickHandler={handleReplaceButtonClick}
    >
      {isReasonsRequired ? (
        <>
          <ReasonContainerComponent />
          {isImageRequired && <DTImageSelector selectedImages={selectedImages} onSelect={setSelectedImages} />}
        </>
      ) : (
        <BlankReasonContainer />
      )}
    </DTSelectedItemTransactionView>
  );
};

export default withConfirmation(DTReplaceSelectedItemsNode);
